export const NAME_ACTION = ['Добавление', 'Изменение', 'Удаление', 'Включение', 'Отключение', 'Рестарт']
// Платформа сервера: id_media_core 1 - NimbleStreamer (ВК 2.0), 2 - MediaMTX (ВК 3.0).
export const MEDIA_CORE = { VK2: 1, VK3: 2 };
export const MEDIA_CORE_NAME = { 1: "Nimble", 2: "MediaMTX" };
